import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';


type Props = {
    // buttonText: string,
    // languageExchange:any,
}
export const NFTRecievingMessage: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const NFTRecievingMessageComponent = styled.p`
    margin-top: 40px;
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 0;
    margin-bottom: 0;
  `;
    // margin: 30px 0 0 0;
  return (
    <NFTRecievingMessageComponent id="nftrecievingmessage">{t('NFTを受信しています')}</NFTRecievingMessageComponent>
  );
};